import * as React from 'react';
import { useEffect, useState, useMemo } from 'react';
import BentoBox from '../BentoBox';
import { BentoBox as BentoBoxType } from 'types/generated';
import { fetchBentoBoxes } from '@/clients/BentoBoxUtils';
import { PlaceholderBox } from './PlaceHolderBox';

interface BentoBoxItem {
  sys: {
    id: string;
  };
}

interface BentoBoxId {
  data: {
    items: BentoBoxItem[];
  };
}

const LayoutNine = ({ data }: BentoBoxId) => {
  const bentoBoxIds = useMemo(() => data?.items?.slice(0, 4).map((item: BentoBoxItem) => item?.sys?.id) || [], [data]);

  const [bentoBoxes, setBentoBoxes] = useState<BentoBoxType[]>([]);

  useEffect(() => {
    const fetchBox = async () => {
      if (bentoBoxIds.length) {
        const fetchedBoxes = await fetchBentoBoxes(bentoBoxIds);
        if (fetchedBoxes) {
          setBentoBoxes(fetchedBoxes);
        }
      }
    };
    fetchBox();
  }, [bentoBoxIds]);

  if (bentoBoxes.length < 4) {
    return (
      <>
        {/* Mobile view: show only the first box */}
        <div className="block min-h-[70vh] w-full md:hidden">
          <PlaceholderBox />
        </div>

        {/* Desktop view */}
        <div className="hidden min-h-[70vh] w-full md:flex">
          <div className="w-3/5">
            <PlaceholderBox />
          </div>
          <div className="mx-16 flex h-full w-2/5 flex-col">
            <div style={{ height: 'calc(((100% - 16px) / 2))' }}>
              <PlaceholderBox />
            </div>
            <div style={{ height: '16px' }} />
            <div style={{ height: 'calc(((100% - 16px) / 2))' }}>
              <div className="flex h-full w-full">
                <div style={{ width: 'calc(((100% - 16px) / 5) * 3)' }}>
                  <PlaceholderBox />
                </div>
                <div style={{ width: '16px' }} />
                <div style={{ width: 'calc(((100% - 16px) / 5) * 2)' }}>
                  <PlaceholderBox />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      {/* Mobile view: show only the first box */}
      <div className="block min-h-[70vh] w-full md:hidden">
        <BentoBox box={bentoBoxes[0]} />
      </div>

      {/* Desktop view */}
      <div className="hidden min-h-[70vh] w-full md:flex">
        <div className="w-3/5">
          <BentoBox box={bentoBoxes[0]} />
        </div>
        <div className="mx-16 flex h-full w-2/5 flex-col">
          <div style={{ height: 'calc(((100% - 16px) / 2))' }}>
            <BentoBox box={bentoBoxes[1]} />
          </div>
          <div style={{ height: '16px' }} />
          <div style={{ height: 'calc(((100% - 16px) / 2))' }}>
            <div className="flex h-full w-full">
              <div style={{ width: 'calc(((100% - 16px) / 5) * 3)' }}>
                <BentoBox box={bentoBoxes[2]} />
              </div>
              <div style={{ width: '16px' }} />
              <div style={{ width: 'calc(((100% - 16px) / 5) * 2)' }}>
                <BentoBox box={bentoBoxes[3]} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LayoutNine;
